export const LAYOUT_LABELS = {
  title_slide: '타이틀', content: '내용', content_with_diagram: '다이어그램',
  section_header: '섹션', two_column: '2단', quiz: '퀴즈', summary: '정리',
};

export const Q_TYPE_LABELS = {
  multiple_choice: '객관식', short_answer: '단답형', essay: '서술형',
  true_false: 'OX', fill_blank: '빈칸', matching: '연결',
  sequencing: '순서배열', categorizing: '분류',
};

export const SECTION_TYPE_LABELS = {
  motivation: '동기유발', concept: '개념정리', group_activity: '모둠활동',
  individual_activity: '개별활동', discussion: '토론', inquiry: '탐구',
  experiment: '실험', summary: '정리', reflection: '성찰',
  graphic_organizer: '사고정리', reading: '읽기', writing: '쓰기',
  presentation: '발표준비', brainstorm: '브레인스토밍', roleplay: '역할극',
  gallery_walk: '갤러리워크', jigsaw: '직소활동', free: '활동',
};
